import { render, staticRenderFns } from "./CellphoneIcon.vue?vue&type=template&id=8c36b18e&"
import script from "./CellphoneIcon.vue?vue&type=script&lang=js&"
export * from "./CellphoneIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports